import { useEffect } from 'react';
import NProgress from 'nprogress';
import {
  Box,
  LinearProgress,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';

import { useTheme } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: '100%',
    padding: theme.spacing(3),
  },
}));

function LoadingScreen() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={classes.root}>
      <Box width={isMobile ? '100%' : 400}>
        <LinearProgress />
      </Box>
    </div>
  );
}

export default LoadingScreen;
